module.exports = __webpack_public_path__ + "static/img/03.b492db3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/znhy/03.jpg
// module id = QoWR
// module chunks = 1